import { render, staticRenderFns } from "./SupplierPayments.vue?vue&type=template&id=950648e2&scoped=true&"
import script from "./SupplierPayments.vue?vue&type=script&lang=js&"
export * from "./SupplierPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "950648e2",
  null
  
)

export default component.exports